// One endpoint's reach as the shared diagram's cards and lines (reachGraph.ts): the endpoint card,
// with the EF Core entities it reaches, then the files and members its handler reaches.
import type { CodeEndpoint, CodeMap, EndpointReach } from '@modelviewer/core';
import type { Graph, Measure, PropertyMode } from '../diagram/graph';
import { codeIndex } from './codeIndex';
import { buildReachGraph, headRow } from './reachGraph';

/** The endpoint's card id: never a file path. */
export const ENDPOINT_CARD = '@endpoint';

export function endpointLabel(e: CodeEndpoint): string {
  return `${e.methods.join(', ') || 'ANY'} ${e.route}`;
}

export function buildEndpointGraph(map: CodeMap, reach: EndpointReach, options: { members: PropertyMode; measure?: Measure }): Graph {
  const index = codeIndex(map);
  const { endpoint } = reach;
  return buildReachGraph(
    map,
    reach,
    {
      id: ENDPOINT_CARD,
      key: endpoint.id,
      label: endpointLabel(endpoint),
      badges: [endpoint.kind === 'controller' ? 'controller' : 'minimal API'],
      table: endpoint.route,
      // The endpoint card lists the data it reaches.
      lines: reach.data.map((id) => headRow(`data:${id}`, index.types.get(id)?.name ?? id, 'data', 'data')),
      // The endpoint to its handler (a controller action, or a method a minimal API endpoint names).
      starts: endpoint.handler ? [{ id: 'handler', member: endpoint.handler, label: 'handles' }] : [],
      own: { id: endpoint.sameHandler ?? endpoint.id, label: endpointLabel(endpoint) },
    },
    options,
  );
}
